import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=095e6bda&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=095e6bda&lang=less&scoped=true"
import style1 from "./Settings.vue?vue&type=style&index=1&id=095e6bda&lang=less"
import style2 from "./Settings.vue?vue&type=style&index=2&id=095e6bda&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e6bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095e6bda')) {
      api.createRecord('095e6bda', component.options)
    } else {
      api.reload('095e6bda', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=095e6bda&scoped=true", function () {
      api.rerender('095e6bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings.vue"
export default component.exports